import styled from 'styled-components';
import { Form } from 'informed';

export const Document = styled.div`
  font-family: Arial, sans-serif;
  margin: 20px;
  line-height: 1.5;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const SubTitle = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
`;

export const Paragraph = styled.p`
  font-size: 16px;
  margin-bottom: 15px;
`;

export const UnorderedList = styled.ul`
  margin-left: 20px;
  list-style-type: disc !important;
`;

export const OrderedList = styled.ol`
  margin-left: 20px;
  list-style-type: decimal;
`;

export const Bold = styled.strong`
  font-weight: bold;
`;

export const Italic = styled.em`
  font-style: italic;
`;

export const FormContainer = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DivSelectForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
`;

export const DivFather = styled.div`
  width: 100%;
  margin-top: 24px;
  background: #FAFAFB;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DivConteiner = styled.div`
  width: 1000px;
  height:100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
`;

export const DivBody = styled.div`
  width: 100%;
  height: 100%;
`;

export const DivCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  width: 97%;
  /* height: 389px; */
  /* padding: 25px; */
  /* width: c(100% - 250px); */
`;

export const DivHeaderForm = styled.div`
  width: 100%;
  display: flex;
  height: 153px;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  background: #F4F4F4;
`;

export const SpanTitle = styled.span`
  margin-left: 15px;
  color: #727780;
  font-family: Public Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 26px;
  margin-top: 19px;
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background: #F0F1F2;
  margin: 33px 0;
`;

export const DivGenero = styled.div`
  width: 100%;
  height: 100%;
  margin: 20px 20px;
`;

export const DivButtonDelete = styled.div`
  margin-right: 40px;
  margin-top: -18px;
  margin-bottom: 20px;
  padding: 10px 0px;
  display: flex;
  justify-content: flex-end;
`;

export const DivButtonPreVisualizar = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  margin-left: 20px;
  align-items: center;
  justify-content: start;
`;

export const ButtonPreVisualizar = styled.button`
  width: 200px;
  height: 30px;
  border-radius: 15px;
  background: rgba(217, 217, 217, 0.20);
  color: #4A4F58;
  text-align: center;
  font-family: Public Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  border: transparent;
`;

export const DivButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  border-radius: 8px;
  height: 40px;
  background: #F0F1F2;
  color: #0047B6;
  font-family: Public Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-top: 40px;
  margin-bottom: 40px;
`;

export const ButtonCancelar = styled.button`
  width: 126px;
  height: 40px;
  border-radius: 24px;
  border: transparent;
  background: transparent;

  color: #0047B6;
  font-family: Public Sans;
  font-size: 14px;
  font-weight: 900;

  :disabled {
    cursor: not-allowed;
    color: #F0F1F2;
  }
`;

export const ButtonPadrao = styled.button`
  min-width: 126px;
  height: 40px;
  border-radius: 24px;
  background: #0047B6;
  border: transparent;

  color: #FFF;
  text-align: center;
  font-family: Public Sans;
  font-size: 14px;
  font-weight: 700;

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ButtonGerar = styled.button`
  min-width: 126px;
  height: 40px;
  border-radius: 24px;
  background: #5d9c5c;
  margin-left: 5px;
  margin-right: 5px;
  border: transparent;

  color: #FFF;
  text-align: center;
  font-family: Public Sans;
  font-size: 14px;
  font-weight: 700;

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;


export const ButtonDelete = styled.button`
  display: flex;
  align-items: center;
  width: 30px;
  justify-content: center;
  color: #E96240;
  border: transparent;
  background: transparent;
  font-family: Public Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

export const DivButtonSalvar = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 96%;
  margin-bottom: 20px;
`;
